import React from "react";
import { useDispatch, useSelector } from "react-redux";
import classnames from "classnames";
import { FormattedMessage } from "react-intl";

import { useMount } from "@sportal/cdk/hooks";
import { SpsonBanner } from "../spson/spsonBanner/SpsonBanner";
import { Desktop, TabletMobile } from "../../hocs/Responsive";
import { isSPSONAvailable } from "../../store/account";
import { anyNewRequests } from "../../store/devices/devices.selectors";
import { BarChartSection } from "./barChartSection/BarChartSection";
import { WidgetsSection } from "./widgets/WidgetsSection";
import { NewRequests } from "./NewRequests";
import { changeProfile } from "../../store/reports/reports.actions";

import "./Dashboard.scss";

const getRowClasses = (showAside) =>
  classnames("dashboard-row", {
    "with-aside": showAside,
  });

export const ChartTitle = ({ title }) => (
  <h3 className="chart-title">{title}</h3>
);

export const Dashboard = () => {
  const dispatch = useDispatch();

  const showSPSON = useSelector(isSPSONAvailable);
  const hasNewRequests = useSelector(anyNewRequests);

  useMount(() => {
    dispatch(changeProfile("all_profiles"));
  });

  return (
    <div className="home-page__dashboard">
      <h1 className={"home-page__title"}>
        <FormattedMessage id={"dashboard"} />
      </h1>
      {showSPSON && <SpsonBanner />}
      {hasNewRequests && (
        <TabletMobile>
          <NewRequests />
        </TabletMobile>
      )}
      <div className={getRowClasses(hasNewRequests)}>
        <WidgetsSection />
        {hasNewRequests && (
          <Desktop>
            <NewRequests />
          </Desktop>
        )}
      </div>
      <div className="dashboard-row">
        <BarChartSection />
      </div>
    </div>
  );
};
